import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import type { IPropsWithStyles } from '@fluentui/react/lib/Utilities';
import type { IStyle, ITheme } from '@fluentui/react/lib/Styling';
export type { ColorScheme };

/**
 * Types of items that can be displayed by the ShowAsBar.
 */
export enum ShowAsType {
    Free,
    Busy,
    Tentative,
    OOF,
    WorkingElsewhere,
    NoInformation,
    OutsideWorkingHours,
}

/**
 * Settings for the ShowAsBar control.
 */
export interface ShowAsBarSettings {
    colorScheme: ColorScheme;
    showAs?: ShowAsType;
    style?: React.CSSProperties;
}

/** Styling properties of the ShowAsBar control. */
export interface ShowAsBarStyleProps {
    theme?: Pick<ITheme, 'palette'>;
    className?: string;
    showAs: ShowAsType;
}

/** Styles of the ShowAsBar control. */
export interface ShowAsBarStyles {
    root?: IStyle;
}

/** All settings and styling properties of the ShowAsBar control. */
export type ShowAsBarProps = ShowAsBarSettings &
    ShowAsBarStyleProps &
    IPropsWithStyles<ShowAsBarStyleProps, ShowAsBarStyles>;
